<template>
  <v-btn-toggle v-if="showHelp" v-model="chatOpen" dense group>
    <v-btn icon :color="color" x-large :value="true" @click="openChat">
      <v-icon>mdi-help-circle-outline</v-icon>
    </v-btn>
  </v-btn-toggle>
</template>

<script>
import { Config, CommonSecurity } from '@dav/security-component-spa';

export const loadChatBubble = () => postMessage({ type: 'DAV_LOAD_CHAT_BUBBLE' }, '*');
export const unloadChatBubble = () => postMessage({ type: 'DAV_UNLOAD_CHAT_BUBBLE' }, '*');

export default {
  tag: 'dav-chat-bubble',
  props: {
    color: {
      type: String,
      default: 'white',
      required: false,
    },
  },
  data: () => ({
    allReady: false,
    currentUser: undefined,
    chatOpen: false,
    showHelp: false,
  }),
  computed: {
    setup() {
      return this.$store.getters['company/SETUP'];
    },
    settings() {
      return this.$store.getters['settings/GET_ONE'];
    },
  },
  watch: {
    allReady(ready) {
      if (ready) this.createBubble();
    },
  },
  async created() {
    const config = await Config.getInstance();
    const vm = this;

    await Promise.allSettled([
      new Promise((resolve) =>
        CommonSecurity.getUser().then((user) => {
          vm.currentUser = user;
          resolve();
        })
      ),
      new Promise((resolve) => {
        if (vm.settings) {
          resolve();
        } else {
          this.$store.dispatch('settings/FETCH_ONE', { companyId: config.get('dav-company-id') }).then(() => resolve());
        }
      }),
    ]);

    this.allReady = true;
  },
  mounted() {
    const vm = this;
    if (this.allReady) this.createBubble();
  },

  beforeDestroy() {
    this.destroyBubble();
  },
  methods: {
    openChat() {
      this.chatOpen = !this.chatOpen;
      document.querySelector('chat-widget')?.shadowRoot?.querySelector('button')?.click();
    },

    createBubble() {
      const vm = this;
      if (
        this.settings?.additional?.clinic_chat_bubble_help === true &&
        this.currentUser.attributes.get('custom:roles') === 'P'
      ) {
        if (!document.getElementById('dav-chat-bubble-script')) {
          const script = document.createElement('script');
          script.src = 'https://chat-api.spartez-software.com/chat-widget.js';
          script.async = true;
          script.id = 'dav-chat-bubble-script';

          script.onload = () => {
            const vm = this;
            const widget = document.createElement('chat-widget');
            widget.setAttribute('jira-id', '1684d9b1-3867-37a5-bef1-63348107c016');
            widget.setAttribute('service-desk-id', '1');
            widget.id = 'dav-chat-bubble-widget';

            window.addEventListener('message', (event) => {
              if (event?.data?.type === 'DAV_LOAD_CHAT_BUBBLE') vm.showBubble();
            });

            window.addEventListener('message', (event) => {
              if (event?.data?.type === 'DAV_UNLOAD_CHAT_BUBBLE') vm.hideBubble();
            });

            document.body.appendChild(widget);
            document.querySelector('chat-widget').onclose = () => (vm.chatOpen = false);
            this.showHelp = true;
          };

          document.head.appendChild(script);
        }
      }
    },

    showBubble() {
      const widget = document.querySelector('chat-widget');
      this.showHelp = true;
      if (widget) widget.show();
    },

    hideBubble() {
      const widget = document.querySelector('chat-widget');
      this.showHelp = false;
      if (widget) widget.hide();
    },

    destroyBubble() {
      this.showHelp = false;
      const widget = document.getElementById('dav-chat-bubble-widget');
      const script = document.getElementById('dav-chat-bubble-script');
      if (widget) document.body.removeChild(widget);
      if (script) document.head.removeChild(script);
    },
  },
};
</script>

<style>
chat-widget::part(wrapper) {
  bottom: -30px;
}

chat-widget::part(icon-button) {
  display: none;
}
</style>
